<template>
  <div class="commentList">
    <template v-if="!isLoading">
      <template v-if="isLoadingCommentsFired">
        <p v-if="!comments || !comments.length" class="color-inactive">{{ $t('YouNotHaveComments') }}</p>
      </template>
      <div class="comment" :class="{'commentNotPublished':comment.is_published === false }"
           v-for="comment in comments"
           :key="comment.id">
        <a class="comment__header" :href="comment.product.get_absolute_url" target="_blank">
          <div class="comment__header__image">
            <img :src="comment.product.image" alt="Product">
          </div>
          <div class="comment__header__title">{{ comment.product.title }}</div>
          <div v-if="!comment.is_published" class="comment__header__status">({{ $t('CommentWaitingPublication') }})</div>
        </a>
        <div class="comment__content">
          <div class="comment__content__date">
            {{ comment.created_date }}
          </div>
          <div class="comment__content__images">
            <div class="comment__content__images__item"
                 v-for="image in comment.images"
                 :key="image.id">
              <img class="comment__content__images__item__content" :src="image.url" alt="Comment">
            </div>
          </div>
          <div class="comment__content__text">
            {{ comment.text }}
          </div>
        </div>
      </div>
      <div v-if="isMore" class="show-more" @click="getCommentsUser(client_id)">
        <img :src="logoLoad" alt="load"/>
        {{ $t('ShowMore') }}
      </div>
    </template>
    <template v-else>
      <dashboard-local-preloader/>
    </template>
  </div>
</template>

<script>

import DashboardLocalPreloader from "@/components/LocalPreloader.vue";
import {actionTypes, getterTypes, mutationTypes} from "@/store/modules/comments";
import {mapGetters} from "vuex";

export default {
  name: 'DashboardCommentList',
  components: {
    DashboardLocalPreloader,
  },
  data(){
    return {
      logoLoad: require('@/assets/svg/arrow-clockwise.svg'),
      isLoadingCommentsFired: false
    }
  },
  mounted() {
    this.$store.commit(mutationTypes.clearComments)
    if (this.client_id){
      this.getCommentsUser(this.client_id)
    }
  },
  computed: {
    ...mapGetters({
      comments: getterTypes.comments,
      isLoading: getterTypes.isLoading,
      isMore: getterTypes.isMore,
    }),
    client_id(){
      return this.$store.state.auth.currentUser ? this.$store.state.auth.currentUser.id : ''
    }
  },
  watch: {
    client_id: function (val) {
      this.$store.commit(mutationTypes.clearComments)
      this.getCommentsUser(val)
    }
  },
  methods: {
    getCommentsUser(client_id){
      this.$store.dispatch(actionTypes.getComments, {client__id: client_id}).then(() => {
        this.isLoadingCommentsFired = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";

  .comment{
    &List{
      padding-top: 40px;
      padding-bottom: 40px;
    }

    border: 1px solid #ede8e8;
    border-radius: 10px;
    margin-top: 10px;
    margin-bottom: 10px;

    &__header{
      display: flex;
      flex-flow: row;
      padding: 15px 15px 25px 15px;
      text-decoration: none;
      color: $black-75;
      &__image{
        padding-right: 20px;
        img{
          width: 40px;
          height: 40px;
        }
      }
      &__title{
        display: flex;
        align-items: center;
        padding-right: 20px;
        text-decoration: none;
        font-weight: 600;
        &:hover{
          color: $fi;
        }
      }
      &__status{
        display: flex;
        margin: 0 0 0 auto;
        font-size: 0.8rem;
        color: $inactive;
      }
    }
    &__content{
      padding: 15px 15px 15px 15px;
      &__images{
        display: flex;
        flex-flow: row;
        flex-wrap: wrap;
        align-items: center;
        &__item{
          padding-top: 5px;
          padding-bottom: 5px;
          margin-left: 20px;
          img{
            height: 100px;
            object-fit: cover;
          }
          &:first-child{
            margin-left: 0;
          }
        }
      }
      &__text{
        color: $black-75;
      }
    }
  }
  .commentNotPublished{
    background-color: $inactive-light;
  }

  .show-more{
    margin-top: 50px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding-top: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid #e9e9e9;
    cursor: pointer;
    color: $fd;
    font-weight: 900;
    img{
      width: 35px;
      height: 35px;
      margin-right: 10px;
      margin-left: 10px;
    }
  }
</style>